<template>
  <transition :name="transitionName" appear>
    <div
      class="tw-absolute tw-w-full tw-select-none tw-p-px"
      :style="blockStyle"
      style="pointer-events: none"
    >
      <div
        class="tw-h-full tw-w-full tw-overflow-hidden tw-text-ellipsis tw-rounded tw-border tw-border-solid tw-p-1 tw-text-xs"
        :class="containerClass"
        :style="containerStyle"
      >
        <div :class="textColor" class="ph-no-capture tw-font-medium">
          {{ noEventNames ? "MEETING TIME" : calendarEvent.summary }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// Fixed calendar event color
const CALENDAR_EVENT_COLOR = "#4285F4" // Google Calendar blue

export default {
  name: "CalendarEventBlock",
  props: {
    blockStyle: {
      type: Object,
      default: () => ({}),
    },
    calendarEvent: {
      type: Object,
      required: true,
    },
    isGroup: {
      type: Boolean,
      required: true,
    },
    isEditingAvailability: {
      type: Boolean,
      required: true,
    },
    noEventNames: {
      type: Boolean,
      required: true,
    },
    transitionName: {
      type: String,
      required: true,
    },
  },
  computed: {
    containerClass() {
      if (this.isGroup && !this.isEditingAvailability) {
        return this.calendarEvent.free
          ? "tw-border-white tw-bg-light-blue tw-opacity-50"
          : "tw-border-white tw-bg-light-blue"
      }
      // For editing availability mode - use calendar color
      return this.calendarEvent.free
        ? "tw-border-dashed"
        : ""
    },
    containerStyle() {
      // Only apply calendar color when not in group view
      if (this.isGroup && !this.isEditingAvailability) {
        return {}
      }
      return {
        backgroundColor: `${CALENDAR_EVENT_COLOR}35`,
        borderColor: CALENDAR_EVENT_COLOR,
      }
    },
    textColor() {
      if (this.isGroup && !this.isEditingAvailability) {
        return "tw-text-white"
      }
      // Use the calendar color for text when editing availability
      return this.noEventNames ? "tw-text-dark-gray" : "tw-text-[#4285F4]"
    },
  },
}
</script>
